import { API } from '@/api';
import { parseLocaleInt, parseLocaleNumber } from '@/utils/numbers';
import type {
  CreateInvestmentData,
  InvestmentData,
  UpdateInvestmentData,
} from '@/dialogs/InvestmentDialog/types';

export const classes = {
  dialog:
    'w-[98vw] min-w-[250px] max-w-[450px] min-h-[150px] max-h-[98vh] flex flex-col',
  dialogTitle: 'pb-2 items-center',
  body: 'w-full mt-4',
  input: 'w-full mb-6 mx-0',
};

export function createInvestment({
  investorId,
  companyId,
  ...data
}: CreateInvestmentData) {
  return API.Investments.createNewInvestment({
    ...formatData(data),
    investorId,
    companyId,
    currency: 'EUR', // TODO
  });
}

export function updateInvestment({
  investmentId,
  ...data
}: UpdateInvestmentData) {
  return API.Investments.updateInvestment(investmentId, formatData(data));
}

function formatData(data: InvestmentData) {
  return {
    date: data.date.toISOString(),
    price: getPrice(data.shareCount, data.sharePrice).toString(),
    shareCount: parseLocaleInt(data.shareCount),
  };
}

function getPrice(shareCount: string, sharePrice: string) {
  return parseLocaleInt(shareCount) * parseLocaleNumber(sharePrice);
}
